import i18n from "i18next";
import i18nLangDet from "i18next-browser-languagedetector";
import $i18n from "jquery-i18next";
import resources from '../locales';

const $ = require('jquery');
require('libs/bootstrap-3.3.2-dist/js/bootstrap.min');

$(function () {
    $i18n.init(i18n, $, {
        tName: 't', // --> appends $.t = i18next.t
        i18nName: 'i18n', // --> appends $.i18n = i18next
        handleName: 'i18n', // --> appends $(selector).localize(opts);
        selectorAttr: 'data-i18n', // selector for translating elements
        targetAttr: 'i18n-target', // data-() attribute to grab target element to translate (if diffrent then itself)
        optionsAttr: 'i18n-options', // data-() attribute that contains options, will load/set if useOptionsAttr = true
        useOptionsAttr: false, // see optionsAttr
        parseDefaultValueFromContent: true // parses default values from content ele.val or ele.text
    });

    i18n.use(i18nLangDet)
        .init({
            fallbackLng: 'el',
            initImmediate: false,
            resources,
            whitelist: ['en', 'el'],
            detection: {
                order: ['localStorage', 'querystring', 'cookie', 'navigator', 'htmlTag']
            }
        }, main.bind(this));

});

function main(t) {
    var match = window.location.href.match(/#(.*)$/);
    var code = match ? match[1] : null;
    $('[data-i18n]').i18n();
    $('html').attr('lang', i18n.options.lng);

    if (!code) {
        $("#optout").hide();
        console.log("Code missing");
        return;
    }
    $("#optout-btn").on("click", handler.bind(this, code));
    console.log(`Init for code=${code}`);
}

async function handler(code) {
    try {
        const data = await $.ajax({
            type: "POST",
            url: `/CampaignCloud/uurl/${code}`,
            data: {action: "doit"},
            dataType: "json"
        });
        if (data.outcome == "OK") {
            $("#success").show();
            $("#optout").hide();
        } else {
            $("#noop").show();
            $("#optout").hide();
        }
    } catch (e) {
        $("#failure").show();
        console.error(e);
    }
}
